import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router";
import Signup from "./components/Signup.js";
import CommunityChannel from "./components/CommunityChannel.js";
import PasswordRecovery from "./components/PasswordRecovery.js";
import Login from "./components/Login.js";
import Home from "./components/Home.js";
import Explore from "./components/Explore.js";
import { AuthProvider } from "./context/AuthContext.js";
import { ThemeProvider } from "./context/ThemeContext.js";
import QueryProvider from "./context/QueryProvider.js";
import { CourseProvider } from "./context/CourseContext.js";
import Join from "./components/Join.js";
import Header from "./components/Header.js";
import Classes from "./components/Classes.js";
import SocketLayout from "./components/SocketLayout.js";
import LiveClass from "./components/LiveClass.js";
import ChoosePlan from "./components/ChoosePlan.js";
import SubscriptionVerfication from "./components/SubscriptionVerfication.js";
import OwnerPayoutSetup from "./components/OwnerPayoutSetup.js";
import GroupMemberships from "./components/GroupMemberships.js";
import GroupSettings from "./components/GroupSettings.js";
import AccountSettings from "./components/AccountSettings.js";
import ManualPayouts from "./components/ManualPayouts.js";
import PolicyPage from "./components/PolicyPage.js";

const App = () => {
  return <Home />;
};

const routes = [
  { path: "/forgot-password", element: <PasswordRecovery key="forgot" /> },
  { path: "/reset-password", element: <PasswordRecovery key="reset" reset /> },
  { path: "/settings", element: <AccountSettings /> },
  { path: "/policies/:policy", element: <PolicyPage /> },
  { path: "/join/group/:slug", element: <Join /> },
  { path: "/payouts", element: <ManualPayouts /> },
  { path: "/owner-payouts", element: <OwnerPayoutSetup /> },
  { path: "/group-memberships", element: <GroupMemberships /> },
  { path: "/explore", element: <Explore /> },
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/courses",
    element: <Navigate to="/explore" replace />,
  },
  {
    path: "/choose-plan",
    element: <ChoosePlan />,
  },
  {
    path: "/subscription-verification",
    element: <SubscriptionVerfication />,
  },
  {
    path: "/subscription-successful",
    element: <SubscriptionVerfication />,
  },
  {
    path: "/courses/:slug",
    children: [
      {
        element: <Header />,
        children: [
          {
            index: true,
            element: <Navigate to="classes" replace />,
          },
          {
            path: "classes",
            element: <Classes />,
          },
          {
            path: "learners",
            element: <Navigate to="../settings?setting=members" replace />,
          },
          {
            path: "messages",
            element: <Navigate to="../classes" replace />,
          },
          { path: "settings", element: <GroupSettings /> },
          { path: "channels/:channel", element: <CommunityChannel /> },
          { path: "*", element: <Navigate to="../classes" replace /> },
          {
            path: "classes/:classId/live",
            element: <LiveClass />,
          },
        ],
      },
    ],
  },

  {
    path: "/join/:courseName/:inviteCode/:inviterName/:memberCount",
    element: <Join />,
  },
];

const appRouter = createBrowserRouter([
  {
    element: <SocketLayout />,
    children: routes,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider><AuthProvider>
    <QueryProvider>
    <CourseProvider>
      <RouterProvider router={appRouter} />
    </CourseProvider>
    </QueryProvider>
  </AuthProvider></ThemeProvider>,
);
